<mat-table #table matSort [dataSource]="dataSource">
  <ng-container matColumnDef="Number">
    <mat-header-cell *matHeaderCellDef>Nummer</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.Number}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="CreatedAt">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Opprettet</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.CreatedAt | date:'dd.MM HH:mm'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="SenderName">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Avsender</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.Sender.Name}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="ReceiverName">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Mottaker</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.Receiver.Name}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="ReceiverAddress">
    <mat-header-cell *matHeaderCellDef>Adresse</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.Receiver.Address}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="ReceiverPostCode">
    <mat-header-cell *matHeaderCellDef>Postnr</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.Receiver.PostCode}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="ReceiverPlace">
    <mat-header-cell *matHeaderCellDef>Sted</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.Receiver.City}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="UpdatedAt">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Sist oppdatert</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.OrderUpdatedAt | date:'dd.MM HH:mm'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Status">
    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
    <mat-cell
      *matCellDef="let shipment">{{shipment | shipmentStatusName}}{{shipment.HasDeviations ? ' (avvik)' : ''}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="DeviationName">
    <mat-header-cell *matHeaderCellDef>Avvik</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment | deviationDescription}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="User">
    <mat-header-cell *matHeaderCellDef>Bruker</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.LastUserDisplayName}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Carrier">
    <mat-header-cell *matHeaderCellDef>Bærer</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{getCarrierName(shipment.CarrierId)}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="ParcelCount">
    <mat-header-cell *matHeaderCellDef>Kolli</mat-header-cell>
    <mat-cell *matCellDef="let shipment">{{shipment.Parcels.length}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Assign">
    <mat-header-cell *matHeaderCellDef>Tildeling</mat-header-cell>
    <mat-cell *matCellDef="let shipment">
      <button mat-stroked-button color="primary" *ngIf="shipment.OrderStatus === 'Unassigned'"
              (click)="assign(shipment, $event)">Tildel
      </button>
      <button mat-stroked-button color="warn" *ngIf="shipment.OrderStatus === 'Offer'"
              (click)="unassign(shipment, $event)">Fjern tildeling
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row [hidden]="headersVisible" *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectShipment(row)" [class.selected]="selectedShipments.isSelected(row)" ></mat-row>
</mat-table>
